import { makeStyles } from "@mui/styles";
import React from "react";
import { Colors } from "../../helpers/Colors";
import AddEmployee from "./section/AddEmployee";

const useStyles = makeStyles({
  AddEmployee: {
    backgroundColor: Colors.primaryExtraLight2,
    width: "auto",
    // height: "100vh",
    overflow: "auto",
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

const Employee = () => {
  const classes = useStyles();
  return (
    <main
      className={`${classes.AddEmployee} flex items-center justify-center`}
      style={{ height: "calc(100vh - 58px)" }}
    >
      <section
        className={`${classes.Content} max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6`}
      >
        <AddEmployee />
      </section>
    </main>
  );
};

export default Employee;
